import React from "react";
import styles from "./style.module.scss";

const Modal = ({
    showModal = false,
    children,
    onButtonConfirmClick,
    buttonConfirmText = "تایید",
    defaultIcon,
    customIcon,
    title
}) => {
    return (
        showModal && (
            <>
                <div
                    className={styles.modal__backdrop}
                    style={{
                        display: showModal ? "block" : "none",
                    }}
                ></div>
                <div className={styles.modal}>
                    <section
                        className={styles.modal__main}
                        style={{
                            top: showModal ? "50%" : "-50%",
                        }}
                    >
                        {defaultIcon && (
                            <i class="icon-mail-below font-40">
                                <span class="path1"></span>
                                <span class="path2"></span>
                                <span class="path3"></span>
                                <span class="path4"></span>
                                <span class="path5"></span>
                                <span class="path6"></span>
                            </i>
                        )}
                        {customIcon}
                        {title}
                        {children}
                        {onButtonConfirmClick && (
                            <div className={styles.modal__button}>
                                <button className={styles.modal__button_btn} onClick={onButtonConfirmClick}>
                                    {buttonConfirmText}
                                </button>
                            </div>
                        )}
                    </section>
                </div>
            </>
        )
    );
};
export default Modal;
